import React, { FC } from "react";
import { ChatServerActionLink } from "../../xapp/ChatServerMessage";
import "./ChatChip.scss";

export interface Props {
    readonly option: string | ChatServerActionLink;
    onClick?: (option: string | ChatServerActionLink) => void;
}

const ChatChip: FC<Props> = props => {
    const option = props.option;

    const className: string = (option as ChatServerActionLink).actionUrl ? "chat-chip chat-chip-link" : "chat-chip";

    return (
        <div onClick={() => props?.onClick(option)} className={className}><span>{(option as ChatServerActionLink).label || option}</span></div>
    );
}

export default ChatChip;
